import PublicLayout from "./layout/PublicLayout";

const NotFound = () => {
  return (
    <PublicLayout>
      <section className="min-h-screen flex items-center justify-center">
        <div className="pt-8">
          <div className="mx-auto max-w-screen-sm text-center">
            <h1 style={{ fontSize: "14rem", fontWeight: "bolder" }}>404</h1>
            <p style={{ fontSize: "2rem", fontWeight: "bold" }}>
              Something's missing.
            </p>
            <p>
              Sorry, we can't find that page. You'll find lots to explore on the
              home page.{" "}
            </p>
            <button
              onClick={() => (window.location.href = "/")}
              className="btn btn-primary m-[5rem]"
            >
              Back to Homepage
            </button>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
};

export default NotFound;
